<template>
    <div class="apprentice-simple-card improve-us-widget">
        <div class="component-title">
            <h5 class="title">{{ $t('dashboard.help_us_improve') }}</h5>
        </div>

        <div class="description">
            {{
                $t(
                    'dashboard.do_you_have_a_suggestion_or_idea_to_make_the_apprentice_portal_better_click_on_the_button_below_to_let_us_know_we_will_be_happy_to_contact_you',
                )
            }}
        </div>

        <b-button
            class="btn-improve-us"
            v-b-modal="'improve-us-widget-modal'"
            variant="primary">
            {{ $t('dashboard.help_us_improve') }}
        </b-button>
        <design-2021-dashboard-improve-us-widget-modal-component></design-2021-dashboard-improve-us-widget-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-dashboard-improve-us-widget-component',
};
</script>

<style scoped lang="scss">
.improve-us-widget {
    display: flex;
    flex-direction: column;

    .description {
        color: $text-muted-color;
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
    }

    .btn-improve-us {
        align-self: flex-end;
        background-color: $primary-darken-alternative;

        &:hover {
            background-color: darken($primary-darken-alternative, 10%);
        }
    }
}
</style>
